import { Lager_Treyd_Users, Orders_Companies } from '@/__generated__/graphql';
import { TypedDocumentNode, gql } from '@apollo/client';
import { QueryOptions } from '@treyd-io/core/types/hasura';
import { getGqlQueryParams } from '@treyd-io/core/utils/hasura';

export type CompanyUser = Pick<
  Lager_Treyd_Users,
  | 'user_id'
  | 'company_id'
  | 'company_user_id'
  | 'email'
  | 'first_name'
  | 'last_name'
  | 'identity_verified'
> & {
  company: Pick<Orders_Companies, 'name'>;
};

export type GetImpersonateSearchResultsQueryType = {
  lager_treyd_users: CompanyUser[];
};

export const getImpersonateSearchResultsQuery = (
  queryOptions?: QueryOptions
) => {
  const { queryParams } = getGqlQueryParams(queryOptions);

  return gql`
    query geImpersonateSearchResults {
      lager_treyd_users${queryParams} {
        user_id
        company_id
        company_user_id
        email
        first_name
        last_name
        identity_verified
        company {
          name
        }
      }
    }
  ` as TypedDocumentNode<GetImpersonateSearchResultsQueryType>;
};
